<header>
  <mat-toolbar color="primary" class="app-header justify-content-between">
    <div class="d-flex d-md-none app-name">
      <img class="app-logo-small d-flex" src="/assets/images/logo-header-small.svg" alt="Viessmann"/>
      <div class="divider d-flex"><span class="dot"></span></div>
      <span>{{ title }}</span>
    </div>
    <div class="d-none d-md-flex app-name">
      <img class="app-logo" src="/assets/images/logo-header.svg" alt="Viessmann"/>
      <div class="divider"><span class="dot"></span></div>
      <span>{{ title }}</span>
    </div>
  </mat-toolbar>
</header>
